import { z } from 'zod'

export default z.object({
  __typename: z.literal('Call').default('Call'),
  id: z.number(),
  status: z.string(),
  userId: z.string(),
})
